import React from "react";
import { Box, Typography, Paper, Container } from "@mui/material";

const Term = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Terms and Conditions
        </Typography>

        <Paper elevation={0} sx={{ p: 4, mt: 4 }}>
          <p>
            This site/app is the property of <a href="https://newpitmansinstituteindia.com">https://newpitmansinstituteindia.com</a> and its licensors. So, if you access this site/app then you have to accept our terms and conditions, if you do not accept then don’t access our site/app. We update or
            change our terms and conditions from time to time. We do not give you any notice before making changes to our products and services. So, it’s your responsibility to check everything before making any purchase from our website. BEFORE MAKING A PURCHASE. PLEASE, READ THE FOLLOWING TERMS
            AND CONDITIONS ATTENTIVELY. BEFORE MAKING A PURCHASE. PLEASE, READ THE FOLLOWING TERMS AND CONDITIONS ATTENTIVELY. When you make a purchase, you are agreed to:
            <ul>
              <li>All our agreements, notices, disclosures, and other communication messages via online mode.</li>
              <li>All our features, functionality, and application are available on our site/app.</li>
              <li>Not to use any device or software that interrupts the working of our site/app.</li>
              <li>Respect our privacy and do not use other’s account information.</li>
              <li>Use our services at your sole risk.</li>
            </ul>
          </p>
          <Typography variant="h4" component="h2" gutterBottom align="center">
            How do you use our site/app?
          </Typography>
          <p>
            After login into the <a href="https://newpitmansinstituteindia.com">https://newpitmansinstituteindia.com</a> account, you have to select a payment method to subscribe any plan to take the typing course. So, it’s your responsibility to maintain the confidentiality of your account as well
            as restrict access to your account. And you have to accept all the activities that occur when you make an account or create a password or make a purchase.
          </p>
          <p>
            <a href="https://newpitmansinstituteindia.com">https://newpitmansinstituteindia.com</a> has a right to terminate accounts, remove or edit content, refuse service, and cancel orders without any consent. So, do not do any unauthorized access to our website. And also, do not use our
            site/app data for any unlawful activity or illegal activity.
          </p>
        </Paper>
      </Box>
    </Container>
  );
};

export default Term;
